import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";
import { ADDON_MODAL_CONSTANTS } from "rivals/components/shared/AddonOptions/constants";
import addonStrings from "rivals/components/shared/AddonOptions/strings";
import RivalsButton from "rivals/components/shared/Button";
import CheckMark from "rivals/components/shared/Icons/CheckMark";
import { selectHasAdLite } from "rivals/redux/user/selectors";
import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";
import strings from "./strings";
import { LearnMoreStepProps } from "./types";

const { AD_LITE } = ADDON_MODAL_CONSTANTS;

const { add, billedAsPart, details, learnMore } = strings;
const { purchasedText } = addonStrings;

const LearnMoreStep = ({
  parentPhilter,
  addOn,
  alreadySubscribed,
  addClick
}: LearnMoreStepProps): JSX.Element => {
  const addOnType = `${addOn.type} ${addOn.type}`;

  const userHasAdLite = useSelector(selectHasAdLite);
  const showAdLitePurchased =
    addOn.addOnGroup?.staticGroupType === AD_LITE && userHasAdLite;

  return (
    <div
      className={styles.modalBody}
      {...setData(parentPhilter, "learn-more-step")}
    >
      <div
        className={styles.addOnTitle}
        {...setData(parentPhilter, "addon-name")}
      >
        {addOn.title}
      </div>
      <div className={styles.addOnPrice} {...setData(parentPhilter, "price")}>
        {addOn.formattedPriceString}
      </div>
      <div className={styles.finePrint}>
        {addOn.associatedSubscription &&
          billedAsPart.replace(
            "[subSchool]",
            `${addOn.associatedSubscription.name}`
          )}
      </div>
      <RivalsButton
        buttonText={
          alreadySubscribed || showAdLitePurchased ? purchasedText : add
        }
        className={
          alreadySubscribed || showAdLitePurchased
            ? styles.purchasedButton
            : styles.addOnButton
        }
        disabled={alreadySubscribed || showAdLitePurchased}
        onClick={(): void => addClick()}
        size="small"
        {...setData(parentPhilter, "learn-more-step-add-addon")}
      />
      {learnMore[addOnType] && !!learnMore[addOnType].length ? (
        <>
          <div
            className={styles.detailsTitle}
            {...setData(parentPhilter, "details")}
          >
            {details}
          </div>
          <div>
            <ul>
              {learnMore[addOnType] &&
                learnMore[addOnType].map((valueProp: string, idx: number) => (
                  <li key={idx}>
                    <div className={styles.check}>
                      <Icon
                        component={CheckMark}
                        rev={""}
                        style={{ fontSize: "16px" }}
                        translate="yes"
                      />
                    </div>
                    <div
                      className={styles.valueProp}
                      dangerouslySetInnerHTML={{
                        __html: valueProp
                          .replace("[rivalSchool]", `${addOn.siteName}`)
                          .replace(
                            "[subSchool]",
                            `${
                              addOn.associatedSubscription
                                ? addOn.associatedSubscription.name
                                : "your school"
                            }`
                          )
                      }}
                      {...setData(parentPhilter, `addon-details-${idx + 1}`)}
                    />
                  </li>
                ))}
            </ul>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default LearnMoreStep;
